import React, { useCallback, useEffect, useState } from 'react';
import {Button, Tooltip} from "@heroui/react";

export default function PlayPauseButton({ playerRef }) {
    const [playing, setPlaying] = useState(() => playerRef.current?.isPlaying() ?? false);

    useEffect(() => {
        const player = playerRef.current;
        if (!player) return;

        // Initialize playing state based on current player state
        setPlaying(player.isPlaying() ?? false);

        // Define event handlers
        const handlePlayState = (isPlaying) => () => setPlaying(isPlaying);
        const onPlay = handlePlayState(true);
        const onPause = handlePlayState(false);

        // Add event listeners
        player.addEventListener('play', onPlay);
        player.addEventListener('pause', onPause);

        // Cleanup function
        return () => {
            player.removeEventListener('play', onPlay);
            player.removeEventListener('pause', onPause);
        };
    }, [playerRef]);

    const onToggle = useCallback(() => {
        if (playerRef.current) {
            playerRef.current.toggle();
        }
    }, [playerRef]);

    // Determine which icon to display
    const iconClassName = playing
        ? "hgi-stroke hgi-pause text-2xl ml-0.5"
        : "hgi-stroke hgi-play text-2xl ml-0.5";

    return (
        <Tooltip content={"Press the spacebar to play or pause."}>
            <Button
                size="lg"
                radius="full"
                isIconOnly={true}
                variant="flat"
                onPress={onToggle}
            >
                <i className={iconClassName}></i>
            </Button>
        </Tooltip>
    );
}